@if (added.length > 0) {
  <span>
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{ 'the_following' | ppTranslate }}
    <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}:
  </span>
  <div class="notification__tags">
    @for (item of added; track item; let last = $last) {
      <span>{{ item }} @if (!last) {
        <span>, </span>
      }</span>
    }
  </div>
}

@if (removed.length > 0) {
  <span>
    <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
    {{ 'the_following' | ppTranslate }}
    <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}:
  </span>
  <div>
    @for (item of removed; track item; let last = $last) {
      <span>{{ item }} @if (!last) {
        <span>, </span>
      }</span>
    }
  </div>
}
